'use client';
import CartIcon from '@repo/ui/src/components/Icons/CartIcon';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Button from '@repo/ui/src/components/Button';
import { cTAClicked } from '@repo/ui/src/services/analytics';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface ShopButtonProps {
  data: Array<any>;
  className?: string;
}

const ShopButton = ({ data, className }: ShopButtonProps) => {
  const { t } = useTranslation();
  const { push } = useModal(ModalID.shoppableIngredients);
  return (
    <Button
      size="none"
      className={classNames(className, 'tw-py-2')}
      data-testid="rsi-button"
      onClick={() => {
        push(data);
        cTAClicked({ cta_text: 'Shop Ingredients' });
      }}
    >
      <div className="tw-flex tw-justify-center tw-items-center tw-gap-2">
        <div className="tw-w-6 tw-h-fit">
          <CartIcon color="white" />
        </div>
        <p className="tra-text-web-utl-button-m tw-mb-0 tw-ml-2 tw-tracking-normal">
          {t('recipeContent.shopIngredientsLabel', undefined, { default: 'Shop Ingredients' })}
        </p>
      </div>
    </Button>
  );
};

export default ShopButton;
